import { Skeleton } from '@mui/material'
import { Stack } from '@collaborate-health/uikit'
import { times } from 'lodash'

interface ContentUserQualificationsSkeletonProps {
  skeletonCount?: number
  skeletonWidth?: number
  skeletonHeight?: number
}

const ContentUserQualificationsSkeleton = ({
  skeletonCount = 2,
  skeletonWidth = 200,
  skeletonHeight = 10,
}: ContentUserQualificationsSkeletonProps) => {
  return (
    <Stack gap={2} direction='row'>
      {times(skeletonCount, (index) => (
        <Skeleton key={index} height={skeletonHeight} variant='rounded' animation='wave' width={skeletonWidth} />
      ))}
    </Stack>
  )
}

export default ContentUserQualificationsSkeleton

